module.exports = __webpack_public_path__ + "static/icon-8b026de9a3f2687f0315cf0c11b23ed7.png";